import { render, staticRenderFns } from "./FilterActions.vue?vue&type=template&id=52b2874d&"
import script from "./FilterActions.vue?vue&type=script&lang=js&"
export * from "./FilterActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports